import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as uiAction from '../../modules/ui'
import { getTalkTime } from '../../utils/utils'

class QuestionBalloon extends PureComponent {
    saveFavorite() {
        let type = "add"
        if (this.props.setting.favorite !== null && this.props.setting.favorite.length === 10) {
            type = "warning"
        } 

        this.props.controlOverlay({toggle:true, closeAll:false})
        this.props.openFavoriteAlert({utterance : this.props.data.utterance, action:type})
    }

    render() {
        let isSaved = -1
        if (this.props.favorite !== undefined && this.props.favorite !== null)
            isSaved = this.props.favorite.indexOf(this.props.data.utterance)
        return (
            <div className="user_bubble_area">
                <div className="user_bubble_box">
                   <div className="bubble_unit">
                        { this.props.data.utterance }
                        { isSaved === -1 
                            ? <button type="button" className="btn_bookmark" onClick={() => {this.saveFavorite()}}><span className="ico_comm ico_bookmark">즐겨찾는 질문 추가</span></button>
                            : <div className="btn_bookmark"><span className="ico_comm ico_star_on">즐겨찾는 질문 추가됨</span></div>
                        }
                    </div>
                    <span className="bubble_time">{getTalkTime()}</span>
                </div>
            </div>
        );
    }
};

function mapStateToProps(state) {
    return {...state};
}

function mapDispatchToProps(dispatch) {
    return {
        openFavoriteAlert: (payload) => dispatch(uiAction.openFavoriteAlert(payload)),
        controlOverlay: (payload) => dispatch(uiAction.controlOverlay(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(QuestionBalloon);
